import createIcon from '../../createIcon';

/**
 * @component @name Key
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMTBIMTIuNjVDMTEuODMgNy42NyA5LjYxIDYgNyA2QzMuNjkgNiAxIDguNjkgMSAxMkMxIDE1LjMxIDMuNjkgMTggNyAxOEM5LjYxIDE4IDExLjgzIDE2LjMzIDEyLjY1IDE0SDEzTDE1IDE2TDE3IDE0TDE5IDE2TDIzIDExLjk2TDIxIDEwWk03IDE1QzUuMzUgMTUgNCAxMy42NSA0IDEyQzQgMTAuMzUgNS4zNSA5IDcgOUM4LjY1IDkgMTAgMTAuMzUgMTAgMTJDMTAgMTMuNjUgOC42NSAxNSA3IDE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Key = createIcon('Key', [
  [
    'path',
    {
      d: 'M21 10H12.65C11.83 7.67 9.61 6 7 6C3.69 6 1 8.69 1 12C1 15.31 3.69 18 7 18C9.61 18 11.83 16.33 12.65 14H13L15 16L17 14L19 16L23 11.96L21 10ZM7 15C5.35 15 4 13.65 4 12C4 10.35 5.35 9 7 9C8.65 9 10 10.35 10 12C10 13.65 8.65 15 7 15Z',
      key: 'tdd3me',
    },
  ],
]);

export default Key;
